import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { getTotalItems } = useCart();

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="navbar-brand">
          <h1>Beauty by Sara</h1>
        </Link>
        
        <div className="navbar-nav">
          <Link to="/webshop" className="nav-link">
            Proizvodi
          </Link>
          <Link to="/cart" className="nav-link cart-link">
            Košarica
            {getTotalItems() > 0 && (
              <span className="cart-badge">{getTotalItems()}</span>
            )}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;